import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";

const JoinAgree = (props: any) => {
    const [inputTermYn, setInputTermYn] = useState("N")
    const [inputPrivacyYn, setInputPrivacyYn] = useState("N")
    const [checkTermYnValidation, setCheckTermYnValidation] = useState(false)  // 이용약관 동의 체크여부
    const [checkPrivacyYnValidation, setCheckPrivacyYnValidation] = useState(false) // 개인정보 동의 체크여부
    const [visibleStyle, setVisibleStyle] = useState(true)

    useEffect(() => {
        }, [inputTermYn, inputPrivacyYn, visibleStyle]
    );

    const goToJoinInput = () => {
        if (checkTermYnValidation && checkPrivacyYnValidation) {
            props.getTermYn(inputTermYn)
            props.getPrivacyYn(inputPrivacyYn)
            setVisibleStyle(false)
            props.childVisibleStyle('false')
        } else alert('약관 동의여부에 체크해주세요.')
    };

    const isInputTermYnChecked = (event: any) => {
        setCheckTermYnValidation(true)
        setInputTermYn(event.target.value);
    };

    const isInputPrivacyYnChecked = (event: any) => {
        setCheckPrivacyYnValidation(true)
        setInputPrivacyYn(event.target.value);
    };

    const checkAllAgreement = () => {
        setInputTermYn("Y");
        setInputPrivacyYn("Y");

        setCheckTermYnValidation(true)
        setCheckPrivacyYnValidation(true)
    };

    const termDesc = "의료중심 데이터병원 SHiNE 컨소시움 홈페이지 회원 약관\n" +
        "\n" +
        "\n" +
        "제1장 총 칙\n" +
        "\n" +
        "제1조 (목적)\n" +
        "이 약관은 서울대병원의 의료중심 데이터병원 SHiNE 컨소시움 홈페이지가 제공하는 서비스를 이용함에 있어 이용자와 운영기관인 SHiNE 컨소시움 (이하 \"SHiNE\"이라 합니다)간의 권리·의무 및 책임사항과 기타 필요한 사항을 규정함을 목적으로 합니다.\n" +
        "\n" +
        "제2조 (약관의 효력과 변경)\n" +
        "① 이 약관은 서비스를 이용하고자 하는 모든 이용자에 대하여 그 효력을 발생합니다.\n" +
        "② 이 약관의 내용은 서비스의 일부 화면 또는 기타 방법등에 의하여 이를 공지하거나 그 내용을 이용자에게 통지함으로써 효력이 발생됩니다.\n" +
        "③ SHiNE은 필요하다고 인정되는 경우 이 약관의 내용을 변경할 수 있으며, 변경된 약관은 제2항과 같은 방법으로 공지 또는 통지하여 이용자가 직접 확인할 수 있도록 할 것입니다.\n" +
        "④ 이용자는 변경된 약관에 동의하지 않으실 경우 서비스 이용을 중단하고 본인의 회원등록을 취소할 수 있으며, 계속 사용하시는 경우에는 약관 변경에 동의한 것으로 간주되며 변경된 약관은 전항과 같은 방법으로 효력이 발생합니다.\n" +
        "⑤ 이용자가 이 약관의 내용에 동의하는 경우 SHiNE의 서비스 제공행위 및 이용자의 서비스 이용행위에는 이 약관이 우선적으로 적용될 것입니다. 이 약관에 명시되지 않은 사항에 대해서는 개인정보보호법, 전기통신기본법, 전기통신사업법, 정보통신윤리위원회심의규정, 정보통신윤리강령, 정보통신망이용촉진 및 정보보호 등에 관한 법률, 전자서명법 등 기타 대한민국의 관련법령, SHiNE이 별도로 정한 규정에 의합니다.\n" +
        "\n" +
        "제3조 (용어의 정의)\n" +
        "① 이 약관에서 사용하는 용어의 정의는 다음과 같습니다.\n" +
        "1. 이용자 : 서비스에 접속하여 SHiNE이 제공하는 서비스를 받는 회원 및 비회원\n" +
        "2. 회원 : 만 14세 이상으로 “이용자” 중 SHiNE에 개인정보를 제공하여 ID(고유번호)와 PASSWORD(비밀번호)를 발급 받아 문자 인증 등 확인 절차를 거쳐 회원등록을 한 자\n" +
        "3. 비회원 : 회원가입을 하지 않고 SHiNE이 제공하는 서비스를 이용하는 자\n" +
        "4. ID(고유번호) : 회원 식별과 회원의 서비스 이용을 위하여 이용자가 선정하고 SHiNE이 승인하는 특정 영문자와 숫자의 조합\n" +
        "5. PASSWORD(비밀번호) : 회원의 정보 보호를 위해 이용자 자신이 설정한 문자와 숫자, 특수기호의 조합(8자리 이상)\n" +
        "6. 이용해지 : SHiNE 또는 회원이 서비스 이용 이후 그 이용계약을 종료시키는 의사표시\n" +
        "② 이 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는 관계법령 및 서비스별 안내에서 정하는 바에 의합니다.\n" +
        "\n" +
        "제2장 서비스 이용계약\n" +
        "\n" +
        "제4조 (이용계약의 성립) 이용계약은 이용자의 약관내용에 대한 동의와 이용자의 이용신청에 대한 SHiNE의 승낙으로 성립합니다.\n" +
        "\n" +
        "제5조 (이용신청) 이용신청은 서비스의 회원정보 화면에서 이용자가 SHiNE에서 요구하는 가입신청 양식에 개인의 신상정보를 기록하는 방식으로 신청합니다.\n" +
        "\n" +
        "제6조 (이용신청의 수락과 거절)\n" +
        "① SHiNE은 제5조에서 정한 사항을 정확히 기재하여 이용신청을 하였을 경우 특별한 사정이 없는 한 서비스 이용신청을 수락합니다.\n" +
        "1. 내용이 허위(차명 등)인 것으로 판명되거나, 그러하다고 의심할만한 합리적인 사유가 발생할 경우\n" +
        "2. 기타 SHiNE이 필요하다고 인정되는 경우\n" +
        "② SHiNE은 다음 각 호에 해당하는 경우에 대하여는 그 신청에 대한 제한 사유가 해소될 때까지 일부 서비스 이용을 제한할 수 있습니다.\n" +
        "1. 내용이 허위(차명 등)인 것으로 판명되거나, 그러하다고 의심할만한 합리적인 사유가 발생할 경우\n" +
        "2. 기타 SHiNE이 필요하다고 인정되는 경우\n" +
        "③ SHiNE은 다음에 해당하는 경우에는 이용신청을 제한할 수 있습니다.\n" +
        "1. 다른 사람의 명의를 사용하여 신청하였을 때\n" +
        "2. 신청서의 내용을 허위로 기재하였을 때\n" +
        "3. 사회의 안녕 질서 또는 미풍양속을 저해할 목적으로 신청하였을 때\n" +
        "4. 기타 SHiNE이 정한 이용신청 요건이 미비 되었을 때\n" +
        "제7조 (계약사항의 변경)\n" +
        "회원은 회원정보관리를 통해 언제든지 자신의 정보를 열람하고 수정할 수 있습니다. 회원은 이용신청 시 기재한 사항이 변경되었을 때에는 수정을 하여야 하며, 수정하지 아니하여 발생하는 문제의 책임은 회원에게 있습니다.\n" +
        "\n" +
        "제3장 서비스 제공 및 이용\n" +
        "\n" +
        "제8조 (서비스 이용)\n" +
        "① SHiNE은 회원의 이용신청을 수락한 때부터 서비스를 개시합니다. 단, 일부 서비스의 경우에는 지정된 일자부터 서비스를 개시합니다.\n" +
        "② SHiNE의 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는 경우에는 사이트에 공시하거나 회원에게 이를 통지합니다.\n" +
        "③ 서비스의 이용은 연중무휴 1일 24시간을 원칙으로 합니다. 다만, SHiNE의 업무상 또는 기술상의 이유로 서비스가 일시 중지될 수 있고, 또한 정기점검 등 운영상의 목적으로 SHiNE이 정한 기간에는 서비스가 일시 중지될 수 있습니다. 이러한 경우 SHiNE은 사전 또는 사후에 이를 공지합니다.\n" +
        "④ 회원에 가입한 후라도 일부 서비스 이용 시 서비스 제공자의 요구에 따라 특정 회원에게만 서비스를 제공할 수도 있습니다.\n" +
        "⑤ SHiNE은 서비스를 일정범위로 분할하여 각 범위별로 이용가능 시간을 별도로 정할 수 있습니다. 이 경우 그 내용을 사전에 공지합니다.\n" +
        "제9조 (서비스의 변경, 중지 및 정보의 저장과 사용)\n" +
        "① 회원은 본 서비스에 보관되거나 전송된 메시지 및 기타 통신 메시지 등의 내용이 국가의 비상사태, 정전, SHiNE의 관리범위 외의 서비스 설비 장애 및 기타 불가항력에 의하여 보관되지 못하였거나 삭제된 경우, 전송되지 못한 경우 및 기타 통신 데이터의 손실에 대해 SHiNE이 아무런 책임을 지지않음에 동의합니다.\n" +
        "② SHiNE이 정상적인 서비스 제공의 어려움으로 인하여 일시적으로 서비스를 중지하여야 할 경우에는 서비스 중지 1주일 전에 고지 후 서비스를 중지할 수 있으며, 이 기간 동안 회원이 고지내용을 인지하지 못한데 대하여 SHiNE은 책임을 부담하지 아니합니다. 상당한 이유가 있을 경우 위 사전 고지기간은 감축되거나 생략될 수 있습니다. 또한 위 서비스 중지에 의하여 본 서비스에 보관되거나 전송된 메시지 및 기타 통신 메시지 등의 내용이 보관되지 못하였거나 삭제된 경우, 전송되지 못한 경우 및 기타 통신 데이터의 손실이 있을 경우에 대하여도 SHiNE은 책임을 부담하지 아니합니다.\n" +
        "③ SHiNE의 사정으로 서비스를 영구적으로 중단하여야 할 경우 제2항을 준용합니다. 다만, 이 경우 사전 고지기간은 1개월로 합니다.\n" +
        "④ SHiNE은 사전 고지 후 서비스를 일시적으로 수정, 변경 및 중단할 수 있으며, 이에 대하여 회원 또는 제3자에게 어떠한 책임도 부담하지 아니합니다.\n" +
        "⑤ SHiNE은 회원이 이 약관의 내용에 위배되는 행동을 한 경우, 임의로 서비스 사용을 중지할 수 있습니다. 이 경우 SHiNE은 회원의 접속을 금지할 수 있으며, 회원이 게시한 내용의 전부 또는 일부를 임의로 삭제할 수 있습니다.\n" +
        "제10조 (정보의 제공 및 홍보물의 게재)\n" +
        "① SHiNE은 회원이 서비스 이용 중 필요가 있다고 인정되는 다양한 정보 및 홍보물에 대해서는 전자우편이나 SMS(휴대폰 문자메시지), 카카오톡 알림 등의 방법으로 회원에게 제공할 수 있습니다.\n" +
        "② SHiNE은 서비스의 운용과 관련하여 서비스화면, 홈페이지, 전자우편 등에 홍보물 등을 게재할 수 있으며, SHiNE은 서비스를 이용하고자 하는 이용자가 이 홍보물 게재에 대하여 동의하는 것으로 간주합니다.\n" +
        "③ SHiNE은 서비스 상에 게재되어 있거나 서비스를 통한 홍보주체의 홍보활동에 회원이 참여하거나 교신 등의 결과로서 발생하는 모든 손실 또는 손해에 대해 책임을 지지 않습니다\n" +
        "제11조 (게시물 또는 내용물의 삭제)\n" +
        "① SHiNE은 회원이 게시하거나 등록하는 서비스 내의 모든 내용물이 다음 각 호의 경우에 해당된다고 판단되는 경우 사전 통지 없이 삭제할 수 있으며, 이에 대해 SHiNE은 어떠한 책임도 지지 않습니다.\n" +
        "1. SHiNE, 다른 회원 또는 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우\n" +
        "2. 공공질서 및 미풍양속에 위반되는 내용인 경우\n" +
        "3. 범죄적 행위에 결부된다고 인정되는 내용일 경우\n" +
        "4. 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우\n" +
        "5. 서비스 성격에 부합하지 않는 정보의 경우\n" +
        "6. 기타 관계 법령 및 SHiNE에서 정한 규정 등에 위배되는 경우\n" +
        "② SHiNE은 서비스에 게시된 내용을 사전 통지 없이 편집, 이동, 삭제할 수 있는 권리를 보유하며, 게시된 내용이 이 약관에 위배되거나 상용 또는 비합법적, 불건전한 내용일 경우 사전통지 없이 삭제할 수 있습니다.\n" +
        "③ SHiNE은 게시된 내용이 일정기간 이상 경과되어, 게시물로써의 효력을 상실하여 그 존치 목적이 불분명한 경우 공지사항 발표 후 1주일간의 통지기간을 거쳐 해당 게시물을 삭제할 수 있습니다.\n" +
        "제12조 (게시물의 저작권)\n" +
        "① 서비스에 게재된 모든 자료에 대한 권리와 책임은 게시자에게 있으며 SHiNE은 서비스 내 게재권을 갖습니다. 또한, SHiNE은 게시자의 동의 없이는 게시물을 영리적 목적으로 사용할 수 없습니다. 단, 비영리적인 경우에는 그러하지 않습니다.\n" +
        "② 회원의 게시물이 타인의 저작권, 프로그램 저작권 등을 침해함으로써 발생하는 민, 형사상의 책임은 전적으로 회원이 부담하여야 합니다.\n" +
        "③ 회원은 서비스를 이용하여 얻은 정보를 가공, 판매하는 행위 등 서비스에 게재된 자료를 상업적으로 사용할 수 없습니다.\n" +
        "제13조 (SHiNE의 소유권)\n" +
        "① SHiNE이 제공하는 서비스, 그에 필요한 소프트웨어, 이미지, 마크, 로고, 디자인, 서비스명칭, 정보 및 상표 등과 관련된 지적재산권 및 기타권리는 SHiNE에게 소유권이 있습니다.\n" +
        "② 회원은 SHiNE이 명시적으로 승인한 경우를 제외하고는 제1항 소정의 각 재산에 대한 전부 또는 일부의 수정, 대여, 대출, 판매, 배포, 제작, 양도, 재라이센스, 담보권 설정행위, 상업적 이용행위를 할 수 없으며, 제3자로 하여금 이와 같은 행위를 하도록 허락할 수 없습니다.\n" +
        "제4장 계약 당사자의 의무\n" +
        "\n" +
        "제14조 (회원의 의무 및 정보보안)\n" +
        "① 회원은 서비스 이용을 위해 가입할 경우 현재의 사실과 일치하는 완전한 정보(이하 \"가입정보\"라 한다)를 제공하셔야 합니다. 또한 가입정보에 변경이 발생할 경우 즉시 갱신하셔야 합니다.\n" +
        "② 회원이 서비스 사용을 위한 가입절차를 완료하시면 아이디와 비밀 번호를 받게 됩니다. 회원의 아이디, 비밀번호 관리를 위해\n" +
        "1. 회원의 승인 없이 ID, PASSWORD가 사용되는 문제가 발생되면 즉시 SHiNE에 신고하셔야 하고\n" +
        "2. 매 접속 종료 시 확실히 로그아웃을 하셔야 합니다\n" +
        "③ 회원은 서비스를 이용하면서 다음과 같은 행위를 하여서는 안 됩니다.\n" +
        "1. 다른 이용자의 개인정보를 도용하거나 자신의 개인정보를 제3자에게 이용하게 하는 행위\n" +
        "2. 서비스를 이용하여 얻은 정보를 이용자의 개인적인 이용 외에 복사, 가공, 번역, 2차적 저작 등을 통하여 복제, 공연, 방송, 전시, 배포, 출판 등에 사용하거나 제3자에게 제공하는 행위\n" +
        "3. 타인의 명예를 손상시키거나 불이익을 주는 행위\n" +
        "4. SHiNE의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 행위\n" +
        "5. 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형, 동영상, 음성 등을 타인에게 유포 하는 행위\n" +
        "6. 범죄와 결부된다고 객관적으로 인정되는 행위\n" +
        "7. 서비스와 관련된 설비의 오동작이나 정보 등의 파괴 및 혼란을 유발시키는 컴퓨터 바이러스 감염자료를 등록 또는 유포하는 행위\n" +
        "8. 서비스의 안정적 운영을 방해할 수 있는 정보를 전송하거나 수신자의 의사에 반하여 광고성 정보를 전송하는 행위\n" +
        "9. 정보통신윤리위원회, 소비자보호단체 등 공신력 있는 기관으로부터 시정요구를 받는 행위\n" +
        "10. 선거관리위원회의 중지, 경고 또는 시정명령을 받는 선거법 위반 행위\n" +
        "11. 기타 관계 법령에 위배되는 행위\n" +
        "④ 회원은 이 약관 및 관계법령에서 규정한 사항을 준수하여야 합니다.\n" +
        "제15조 (SHiNE의 의무)\n" +
        "① SHiNE은 법령과 이 약관이 금지하는 행위를 하지 않으며, 계속적, 안정적으로 서비스를 제공하기위해 노력할 의무가 있습니다.\n" +
        "② SHiNE은 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정할 경우에는 신속히 처리하여야합니다.\n" +
        "③ SHiNE은 관련법령이 정하는 바에 따라서 회원 등록정보를 포함한 회원의 개인정보를 보호하기 위하여 노력합니다. 회원의 개인정보보호에 관해서는 관련법령 및 제16조에 제시된 내용을 지킵니다.\n" +
        "제16조 (개인정보보호정책)\n" +
        "① SHiNE은 이용 신청 시 회원이 제공하는 정보를 통하여 회원에 관한 정보를 수집하며, 회원의 개인정보는 본 이용계약의 이행과 본 이용계약상의 서비스제공을 위한 목적으로 이용합니다.\n" +
        "② SHiNE은 서비스 제공과 관련하여 취득한 회원의 정보를 본인의 승낙 없이 제3자에게 누설 또는 배포할 수 없으며 상업적 목적으로 사용할 수 없습니다. 다만, 법률의 규정에 따른 적법한 절차에 의한 경우에는 제외합니다.\n" +
        "제5장 계약해지\n" +
        "\n" +
        "제17조 (계약해지 및 이용제한)\n" +
        "① 회원이 이용계약을 해지하고자 하실 때에는 회원 본인이 직접 인터넷을 통해 당 사이트에 해지 신청을 하여야 합니다.\n" +
        "② SHiNE은 보안 및 아이디 정책, 서비스의 원활한 제공 등과 같은 이유로 회원의 ID 및 PASSWORD변경을 요구하거나 변경 할 수 있습니다.\n" +
        "③ SHiNE은 회원이 다음 각 호의 어느 하나에 해당하는 행위를 하였을 경우 사전통지 없이 이용계약을 해지하거나 서비스 이용을 중지하고 관계당국에 고발할 수 있습니다.\n" +
        "1. 타인의 개인정보, 서비스 ID(고유번호) 및 비밀번호를 도용한 경우\n" +
        "2. 서비스 운영을 고의로 방해한 경우\n" +
        "3. 가입한 이름이 실명이 아닌 경우\n" +
        "4. 동일 사용자가 다른 ID(고유번호)로 이중등록을 한 경우\n" +
        "5. 공공질서 및 미풍양속에 저해되는 내용을 고의로 유포시킨 경우\n" +
        "6. 회원이 국익 또는 사회적 공익을 저해할 목적으로 서비스 이용을 계획 또는 실행하는 경우\n" +
        "7. 타인에 대하여 비방하거나 명예를 손상시키거나 불이익을 주는 행위를 한 경우\n" +
        "8. 서비스의 안정적 운영을 방해할 목적으로 정보를 전송하거나 광고성 정보를 전송하는 경우\n" +
        "9. 통신설비의 오동작이나 정보 등의 파괴를 유발시키는 컴퓨터 바이러스 프로그램 등을 유포하는경우\n" +
        "10. SHiNE, 다른 회원 또는 제3자의 지적재산권을 침해하는 경우\n" +
        "11. 정보통신윤리위원회 등 외부기관의 시정 요구가 있거나 선거관리위원회의 중지, 경고 또는 시정 명령을 받는 선거법 위반행위가 있는 경우\n" +
        "12. SHiNE의 서비스를 이용하여 얻은 정보를 SHiNE의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 경우\n" +
        "13. 게시판 등에 음란물을 게재하거나 음란사이트를 연결(링크)하는 경우\n" +
        "14. 회원이 제공한 정보 및 갱신한 정보가 부정확할 경우\n" +
        "15. 관련 법령, 이용약관 및 기타 SHiNE이 정한 이용조건에 위반한 경우\n" +
        "④ SHiNE은 장기간 휴면상태 회원인 경우 회원 적정관리와 정보보호를 위해 계약을 해지할 수 있습니다. 이 경우 서비스에 공지하거나 이메일로 안내하여야 합니다.\n" +
        "\n" +
        "제6장 기타\n" +
        "\n" +
        "제18조 (요금 및 유료정보)\n" +
        "서비스 이용은 기본적으로 무료입니다. 단, 서비스에서 정한 별도의 유료 정보와 유료서비스에 대해서는 그러하지 아니합니다\n" +
        "\n" +
        "제19조 (양도금지)\n" +
        "회원은 서비스의 이용권한, 기타 이용계약상의 지위를 타인에게 양도, 증여할 수 없으며, 이를 담보로 공할 수 없습니다.\n" +
        "\n" +
        "제7장 손해배상 등\n" +
        "\n" +
        "제20조 (손해배상)\n" +
        "SHiNE은 서비스 이용과 관련하여 이용자에게 어떠한 손해가 발생하더라도 손해가 SHiNE이 고의로 행한 범죄행위를 제외하고 이에 대하여 책임을 부담하지 아니합니다.\n" +
        "\n" +
        "제21조 (면책조항)\n" +
        "① SHiNE은 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.\n" +
        "② SHiNE은 이용자의 귀책사유로 인한 서비스이용의 장애에 대하여 책임을 지지 않습니다.\n" +
        "③ SHiNE은 이용자가 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며 그 밖에 서비스를 통하여 얻은 자료로 인한 손해 등에 대하여도 책임을 지지 않습니다.\n" +
        "④ SHiNE은 이용자가 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.\n" +
        "제22조 (관할법원)\n" +
        "① 서비스 이용과 관련하여 SHiNE과 회원 사이에 분쟁이 발생한 경우, SHiNE과 회원은 발생한 분쟁을 원만하게 해결하기 위하여 필요한 모든 노력을 하여야 합니다.\n" +
        "② 제1항의 규정에도 불구하고 서비스 이용으로 발생한 분쟁에 대하여 소송이 제기될 경우 SHiNE 소재지를 관할하는 법원을 관할법원으로 합니다.\n" +
        "부 칙\n" +
        "(시행일) 이 약관은 2021년 12월 22일부터 적용합니다.";

    const prvtDesc = "의료중심 데이터병원 SHiNE 컨소시움 개인정보 처리방침\n" +
        "\n" +
        "의료중심 데이터병원 SHiNE 컨소시움(이하 ‘SHiNE’)는 서비스기획부터 종료까지 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 ‘정보통신망법’), 개인정보보호법 등 국내의 개인정보 보호 법령을 철저히 준수합니다. 또한, OECD의 개인정보 보호 가이드라인 등 국제 기준을 준수하여 서비스를 제공합니다.\n" +
        " \n" +
        "본 개인정보 처리방침의 목차는 아래와 같습니다.\n" +
        "일부는 관계법령이 개인정보처리방침의 작성에 있어 요구하는 필수 사항을 포함하였고, 나머지는 SHiNE가 자체적으로 이용자의 개인정보보호에 있어 중요하다 판단하는 내용을 추가하였습니다.\n" +
        "\n" +
        "1. 개인정보처리방침의 의의\n" +
        "2. 수집하는 개인정보 (필수 안내사항)\n" +
        "3. 수집한 개인정보의 이용 (필수 안내사항)\n" +
        "4. 개인정보의 제공 및 위탁 (필수 안내사항)\n" +
        "5. 개인정보의 파기 (필수 안내사항)\n" +
        "6. 이용자 및 법정대리인의 권리와 행사 방법 (필수 안내사항)\n" +
        "7. 개인정보보호를 위한 SHiNE의 노력\n" +
        "8. 개인정보 보호책임자 및 담당자 안내 (필수 안내사항)\n" +
        "9. 본 개인정보취급방침의 적용 범위\n" +
        "10. 개정 전 고지 의무\n" +
        "  \n" +
        "\n" +
        "1. 개인정보처리방침의 의의\n" +
        " \n" +
        "SHiNE는 본 개인정보처리방침을 정보통신망법을 기준으로 작성하였으며, SHiNE 내에서의 이용자 개인정보 처리현황을 최대한 알기 쉽고 상세하게 설명하기 위해 노력하였습니다.\n" +
        " \n" +
        "개인정보처리방침은 다음과 같은 중요한 의미를 가지고 있습니다.\n" +
        "•    SHiNE가 어떤 정보를 수집하고, 수집한 정보를 어떻게 사용하며, 필요에 따라 누구와 이를 공유(‘위탁’ 또는 ‘제공’)하며, 이용목적을 달성한 정보를 언제/어떻게 파기하는지 등 ‘개인정보 한살이’와 관련한 정보를 투명하게 제공합니다.\n" +
        "•    정보주체로서 이용자는 자신의 개인정보에 대해 어떤 권리를 가지고 있으며, 이를 어떤 방법과 절차로 행사할 수 있는지를 알려 드립니다. 또한, 개인정보 침해사고가 발생하는 경우, 추가적인 피해를 예방하고 이미 발생한 피해를 복구하기 위해 누구에게 연락하여 어떤 도움을 받을 수 있는지 알려 드립니다.\n" +
        "•    그 무엇보다도, 개인정보와 관련하여 SHiNE와 이용자간의 권리 및 의무 관계를 규정하여 이용자의 ‘개인정보자기결정권’을 보장하는 수단이 됩니다.\n" +
        " \n" +
        "\n" +
        "2. 수집하는 개인정보\n" +
        " \n" +
        "이용자는 회원가입 및 유료 컨텐츠 구입 없이도 컨텐츠 설명 및 미리보기 등이 가능합니다. 이용자가 스티커 등의 유료 컨텐츠 구입시 SHiNE는 서비스 제공(컨텐츠 판매 등의 계약 이행)을 위해 최소한의 개인정보를 수집합니다.\n" +
        " \n" +
        "구매/판매 등 정산을 위하여 수집하는 개인정보는 아래와 같습니다.\n" +
        "•    SHiNE는 서비스 이용(구매/판매등)과 원활한 고객상담, 그외 각종 서비스의 제공과 이용약관에 따른 계약이행을 위하여 LINE메신저로부터 프로필 이름, 프로필 사진, 내부 식별자를 제공받습니다. 그 외에 휴대폰 번호, 단말기 주소록 내에 저장된 전화번호, LINE계정에 등록한 이메일 주소, 페이스북 연동시 발급받은 식별값을 경우에 따라 LINE메신저로부터 제공 받을 수 있습니다.\n" +
        "•    상품결제를 위한 본인확인 과정에서 이름, 생년월일, 성별, 통신사, 휴대폰 번호, 중복가입확인 정보(DI), 암호화된 동일인 식별정보(CI), 미성년자의 법정대리인 정보가 수집될 수 있으며, 상품 결제 과정에서 통신사, 휴대폰 번호, 구매 내역 등의 결제정보가 수집될 수 있습니다.\n" +
        "•    유료 상품 구입시 결제/구매에 관한 내역을 이용자에게 알려주기 위하여, 이메일 주소를 수집할 수 있습니다.\n" +
        " \n" +
        "LINE+는 아래의 방법을 통해 개인정보를 수집합니다.\n" +
        "•    서비스 이용 과정에서 이용자가 개인정보 수집에 대해 동의를 하고 직접 정보를 입력하는 경우, 해당 개인정보를 수집합니다.\n" +
        "•    고객센터를 통한 상담 과정에서 웹페이지, 메일, 팩스, 전화 등을 통해 이용자의 개인정보가 수집될 수 있습니다.\n" +
        "•    오프라인에서 진행되는 이벤트, 세미나 등에서 서면을 통해 개인정보가 수집될 수 있으며, 이러한 경우에는 개인정보 제공 동의 등을 받은 후에 수집합니다.\n" +
        "•    SHiNE와 제휴한 외부 기업이나 단체로부터 개인정보를 제공받을 수 있으며, 이러한 경우에는 정보통신망법에 따라 제휴사에서 이용자에게 개인정보 제공 동의 등을 받은 후에 SHiNE에 제공합니다.\n" +
        "•    기기정보와 같은 생성정보는 PC웹, 모바일 웹/앱 이용 과정에서 자동으로 생성되어 수집될 수 있습니다\n" +
        "﻿\n" +
        "고객문의 처리, 결제내역 고지, 경품 배송 등을 위하여 수집하는 개인정보는 아래와 같습니다.\n" +
        "•    SHiNE는 결재내역 고지, 고객문의 처리와 이벤트 경품 배송 등을 목적으로 연락처(이메일 주소, 전화번호)와 배송정보를 해당 서비스 이용자에 한하여 수집할 수 있습니다. \n" +
        " \n" +
        " 서비스 이용 과정에서 수집하는 개인정보는 아래와 같습니다.\n" +
        "•    서비스 이용 과정 혹은 사업처리 과정에서 IP주소, 쿠키, 방문일시, 부정 이용기록 등의 서비스 이용 기록, 기기 정보가 생성되어 수집될 수 있습니다.\n" +
        " \n" +
        "  \n" +
        "3. 수집한 개인정보의 이용\n" +
        " \n" +
        "SHiNE는 서비스 제공에 따른 계약 이행과 정산, 신규 서비스 개발 등을 위한 목적으로만 개인정보를 이용합니다.\n" +
        "•    유료 서비스 제공에 따르는 본인인증, 구매 및 요금 결제, 상품 및 서비스의 배송을 위하여 개인정보를 이용합니다.\n" +
        "•    서비스 이용 의사의 확인, 연령 확인 및 법정대리인 동의 진행, 이용자 및 법정대리인의 본인 확인, 이용자 식별 등 회원관리를 위하여 개인정보를 이용합니다.\n" +
        "•    콘텐츠 등 기존 서비스 제공(광고 포함)에 더하여, 인구통계학적 분석, 서비스 방문 및 이용기록의 분석, 개인정보 및 관심에 기반한 이용자간 관계의 형성, 지인 및 관심사 등에 기반한 맞춤형 서비스 제공 등 신규 서비스 요소의 발굴 및 기존 서비스 개선 등을 위하여 개인정보를 이용합니다.\n" +
        "•    법령 및 서비스 이용약관을 위반하는 회원에 대한 이용 제한 조치, 부정 이용 행위를 포함하여 서비스의 원활한 운영에 지장을 주는 행위에 대한 방지 및 제재, 계정도용 및 부정거래 방지, 약관 개정 등의 고지사항 전달, 분쟁조정을 위한 기록 보존, 민원처리 등 이용자 보호 및 서비스 운영을 위하여 개인정보를 이용합니다.\n" +
        "•    이벤트 정보 및 참여기회 제공, 광고성 정보 제공 등 마케팅 및 프로모션 목적으로 개인정보를 이용합니다.\n" +
        "•    서비스 이용기록과 접속 빈도 분석, 서비스 이용에 대한 통계, 서비스 분석 및 통계에 따른 맞춤 서비스 제공 및 광고 게재 등에 개인정보를 이용합니다.\n" +
        "•    보안, 프라이버시, 안전 측면에서 이용자가 안심하고 이용할 수 있는 서비스 이용환경 구축을 위해 개인정보를 이용합니다.\n" +
        " \n" +
        " \n" +
        "4. 개인정보의 제공 및 위탁\n" +
        " \n" +
        "SHiNE는 원칙적으로 이용자 동의 없이 개인정보를 외부에 제공하지 않습니다.\n" +
        "SHiNE는 이용자의 사전 동의 없이 개인정보를 외부에 제공하지 않습니다. 단, 이용자가 외부 제휴사의 서비스를 이용하기 위하여 개인정보 제공에 직접 동의를 한 경우, 그리고 관련 법령에 의거해 SHiNE에 개인정보 제출 의무가 발생한 경우, 이용자의 생명이나 안전에 급박한 위험이 확인되어 이를 해소하기 위한 경우에 한하여 개인정보를 제공하고 있습니다. \n" +
        "﻿\n" +
        "SHiNE는 편리하고 더 나은 서비스를 제공하기 위해 업무 중 일부를 외부에 위탁하고 있습니다.  \n" +
        "SHiNE는 서비스 제공을 위하여 필요한 업무 중 일부를 외부 업체에 위탁하고 있으며, 위탁받은 업체가 정보통신망법에 따라 개인정보를 안전하게 취급하도록 필요한 사항을 규정하고 관리/감독을 하고 있습니다.\n" +
        " \n" +
        "•수탁업체 : 네이버 비지니스 플랫폼\n" +
        "•위탁업무 내용 : 서비스 제공을 위한 시스템 개발 및 운영\n" +
        "•개인정보 보유 및 이용기간 : 위탁 계약 종료시까지\n" +
        " \n" +
        "•수탁업체 : LINE Corporation\n" +
        "•위탁업무 내용 : 서비스 제공을 위한 시스템 개발 및 운영\n" +
        "•개인정보 보유 및 이용기간 : 위탁 계약 종료시까지\n" +
        " \n" +
        "•수탁업체 : (주)인컴즈\n" +
        "•위탁업무 내용 : 고객상담, 서비스 운영\n" +
        "•개인정보 보유 및 이용기간 : 위탁 계약 종료시까지\n" +
        " \n" +
        "•수탁업체 : (주)KG모빌리언스\n" +
        "•위탁업무 내용 : 본인확인, 결제처리\n" +
        "•개인정보 보유 및 이용기간 : 위탁 계약 종료시까지\n" +
        " \n" +
        "※ 일부 서비스는 SHiNE와 제휴한 외부 콘텐츠 제공사(CP) 에서 결제 및 환불 등 서비스 이용에 대한 고객상담을 진행할 수 있습니다.\n" +
        " \n" +
        "개인정보 처리위탁 중 국외법인에서 처리하는 위탁업무는 아래와 같습니다.\n" +
        "SHiNE는 이용자의 개인정보를 국외의 다른 사업자에게 제공하지 않습니다. 다만, 데이터 보관 및 서비스 운영 업무를 ‘LINE Corporation’에 아래와 같이 위탁하고 있습니다. ‘LINE Corporation’은  SHiNE와 동일한 정보보호 정책에 따라 이용자의 정보를 보호하며, SHiNE의 엄격한 통제 하에 업무를 수행하고 있습니다.\n" +
        " \n" +
        "•수탁업체 : LINE Corporation\n" +
        "•수탁업체의 위치 : 일본(27F Shibuya Hikarie, 2-21-1 Shibuya, Shibuya-ku, Tokyo)\n" +
        "•위탁 일시 및 방법 : 2014년9월14, 데이터 보관\n" +
        "•정보관리책임자 연락처 : dl_privacy_store@linecorp.com\n" +
        "•위탁하는 개인정보 항목 : SHiNE에서 수집, 보관하는 개인정보를 포함하는 데이터 일체\n" +
        "•위탁업무 내용 : 서비스 제공을 위한 시스템 개발 및 운영\n" +
        "•개인정보의 보유 및 이용기간 : 본 개인정보처리방침에 규정된 보관기간과 일치함 \n" +
        " \n" +
        " \n" +
        "5. 개인정보의 파기\n" +
        " \n" +
        "개인정보 보유기간의 도래와 같이 개인정보의 수집 및 이용목적이 달성된 개인정보는 재생이 불가능한 방법으로 파기하고 있습니다.\n" +
        "전자적 파일 형태의 경우 복구 및 재생이 되지 않도록 기술적인 방법을 이용하여 안전하게 삭제하며, 출력물 등은 분쇄하거나 소각하는 방식 등으로 파기 합니다.\n" +
        " \n" +
        "전자상거래 등에서의 소비자 보호에 관한 법률, 전자금융거래법 등 관계 법령이 정한 범위내에서만 보존합니다.\n" +
        "SHiNE는 이 기간 동안 법령의 규정에 따라 개인정보를 보관하며, 본 정보를 다른 목적으로는 절대 이용하지 않습니다.\n" +
        " \n" +
        "•전자상거래 등에서 소비자 보호에 관한 법률\n" +
        "-    계약 또는 청약철회 등에 관한 기록: 5년 보관\n" +
        "-    대금결제 및 재화 등의 공급에 관한 기록: 5년 보관\n" +
        "-    소비자의 불만 또는 분쟁처리에 관한 기록: 3년 보관\n" +
        " \n" +
        "•전자금융거래법\n" +
        "-    전자금융에 관한 기록: 5년 보관\n" +
        " \n" +
        "•통신비밀보호법\n" +
        "-    로그인 기록: 3개월\n" +
        " \n" +
        " \n" +
        "6. 이용자 및 법정대리인의 권리와 행사 방법\n" +
        " \n" +
        "•만 14세 미만 아동의 경우, 법정대리인이 아동의 개인정보를 조회하거나 수정할 권리, 수집 및 이용 동의를 철회할 권리를 가집니다.\n" +
        "•이용자가 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 해당 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.\n" +
        " \n" +
        " \n" +
        "7. 개인정보보호를 위한 SHiNE의 노력\n" +
        " \n" +
        "SHiNE는 이용자의 개인정보를 안전하게 관리하기 위하여 최선을 다하며, 정보통신망법 및 개인정보보호법에서 요구하는 수준 이상으로 개인정보를 보호하고 있습니다.\n" +
        " \n" +
        "대내외의 보안 위협으로부터 개인정보를 안전하게 관리합니다.\n" +
        "•    해킹이나 도난등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 외부로부터 접근이 통제된 구역에 시스템을 설치하여 운영하고 있습니다.\n" +
        "•    여러 보안시스템을 설치 및 운영하여 외부 해킹으로부터 이용자들의 개인정보를 보호하고 있습니다.\n" +
        "•    암호화 통신 등을 통하여 네트워크상에서 개인정보를 안전하게 송수신하고 있습니다.\n" +
        " \n" +
        "개인정보취급자를 최소한으로 유지하고 있습니다.\n" +
        "•    개인정보를 취급하는 직원을 최소한으로 관리하고 있습니다.\n" +
        "•    개인정보취급자에 대한 정기 교육, 전사 임직원에 대한 수시 교육 및 캠페인을 통하여 회원 개인정보 보호가 SHiNE의 가장 중요한 가치임을 끊임없이 강조하고 있습니다.\n" +
        " \n" +
        "개인정보보호 전담 조직을 운영하고 있습니다.\n" +
        "•    SHiNE는 창사 초기부터 개인정보보호전담조직을 만들어 운영하고 있습니다.\n" +
        "•    현재도 개인정보보호 전담 부서인 보안실에서 전사 임직원이 이용자 개인정보 보호 의무를 올바르게 준수할 수 있도록 기술적/관리적 보호조치를 상시 수행하고 있습니다.\n" +
        " \n" +
        " \n" +
        "8. 본 개인정보처리방침의 적용 범위\n" +
        " \n" +
        "•    본 개인정보처리방침은 ‘LINE STORE(store.line.me)’에 적용되며, 다른 브랜드(혹은 다른 URL, 다른 서비스명)로 제공되는 서비스에 대해서는 별개의 개인정보처리방침이 적용될 수 있습니다.\n" +
        "•    SHiNE에 링크되어 있는 다른 SHiNE의 웹사이트에서 개인정보를 수집하는 경우, 이용자 동의 하에 개인정보가 제공된 이후에는 본 개인정보처리방침이 적용되지 않습니다.\n" +
        "•    보고계시는 개인정보처리방침은 한국내 이용자에게만 적용되며, 한국 외 지역에서 본 서비스를 이용하게 될 경우 별도의 Privacy Policy를 적용합니다.\n" +
        " \n" +
        " \n" +
        "9. 개정 전 고지 의무\n" +
        " \n" +
        "본 개인정보처리방침의 내용 추가, 삭제 및 수정이 있을 경우 개정 최소 7일 전에 ‘공지사항’을 통해 사전 공지를 할 것입니다.\n" +
        "다만, 수집하는 개인정보의 항목, 이용목적의 변경 등과 같이 이용자 권리의 중대한 변경이 발생할 때에는 최소 30일 전에 공지하며, 필요 시 이용자 동의를 다시 받을 수도 있습니다.\n" +
        " \n" +
        "•    공고일자 : 2021년 12월 22일\n" +
        "•    시행일자 : 2021년 12월 22일";

    return (
        <div className={`join-agree-wrapper ${visibleStyle ? 'show' : 'no-show'}`}>
            <div className={`join-agree-item`}>
                <div className={'join-agree-item-title'}>
                    <span>이용약관 동의</span>
                </div>
                <textarea spellCheck={'false'} className={'join-agree-item-textarea'}>
                    {termDesc}
                </textarea>
                <div className={'join-agree-item-input-wrapper'}>
                    <div className={'join-agree-item-input'}>
                        <label>
                            <input type={'radio'} name={'termYn'} value={'Y'} checked={inputTermYn === 'Y'} onChange={isInputTermYnChecked}/>
                            <span>위 약관에 동의합니다.</span>
                        </label>
                    </div>
                    <div className={'join-agree-item-input'}>
                        <label>
                            <input type={'radio'} name={'termYn'} value={'N'} onChange={isInputTermYnChecked}/>
                            <span>위 약관에 동의하지 않습니다.</span>
                        </label>
                    </div>
                </div>
            </div>
            <div className={'join-agree-item'}>
                <div className={'join-agree-item-title'}>
                    <span>개인정보 수집 및 이용 동의</span>
                </div>
                <textarea spellCheck={'false'} className={'join-agree-item-textarea'}>
                    {prvtDesc}
                </textarea>
                <div className={'join-agree-item-input-wrapper'}>
                    <div className={'join-agree-item-input'}>
                        <label>
                            <input type={'radio'} name={'privacyYn'} value={'Y'} checked={inputPrivacyYn === 'Y'} onChange={isInputPrivacyYnChecked}/>
                            <span>위 약관에 동의합니다.</span>
                        </label>
                    </div>
                    <div className={'join-agree-item-input'}>
                        <label>
                            <input type={'radio'} name={'privacyYn'} value={'N'} onChange={isInputPrivacyYnChecked}/>
                            <span>위 약관에 동의하지 않습니다.</span>
                        </label>
                    </div>
                    <div>
                        <div className={'join-agree-item-input flex-center'} >
                            <label>
                                <input type={'radio'} name={'allYn'} value={'Y'}
                                       checked={inputTermYn === 'Y' && inputPrivacyYn === 'Y'} onChange={checkAllAgreement}/>
                                <span>전체 동의</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className={'join-button-wrapper flex-center'}>
                    <div className={'join-button-content flex-space-between'}>
                        <Link to={'/'}><button className={'join-button cancel'}>취소</button></Link>
                        <button className={'join-button confirm'} onClick={goToJoinInput}>확인</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JoinAgree;
